// extracted by mini-css-extract-plugin
module.exports = {"splide__list":"ShowRowSplide_splide__list__I9UFP","splide__slide":"ShowRowSplide_splide__slide__SYo4W","splide__arrow":"ShowRowSplide_splide__arrow__kxSI9"};